import script from './panel-time-pick.vue_vue_type_script_lang.mjs';
export { default } from './panel-time-pick.vue_vue_type_script_lang.mjs';
import { render } from './panel-time-pick.vue_vue_type_template_id_3b3cfa6a_lang.mjs';

script.render = render;
script.__file = "packages/components/time-picker/src/time-picker-com/panel-time-pick.vue";
//# sourceMappingURL=panel-time-pick.mjs.map
